import AppHeader from "@components/app-header";
import Banner from "@components/common/banner/Banner";
import SearchText from "@components/common/search-text";
import CommunityPanel from "@components/sgt/community-panel/CommunityPanel";
import CommunityTabs from "@components/sgt/community-panel/CommunityTabs";
import { PeekBox, PeekGrid, PeekStack, PeekTypography, theme } from "@piiqtechnologies/ui-components";
import { Policy, useCommunities, useDebounce, useError, useLoader, usePolicyContext, } from "@piiqtechnologies/ui-lib";
import { Crown, UserWalking } from "@piiqtechnologies/svg-icons";
import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { useNavigate, useParams } from "react-router-dom";
import { PATHS } from "@constants/Paths";
export const SGTLayout = ({}) => {
    const [getCommunities, communitiesResp, isLoadingCommunities, communitiesError] = useCommunities();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const intl = useIntl();
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    const { communityId } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        getCommunities({
            name: debouncedSearchKey,
        });
    }, [debouncedSearchKey]);
    useEffect(() => {
        communitiesError && setError(communitiesError.message);
    }, [communitiesError]);
    useEffect(() => {
        setLoader(isLoadingCommunities);
        () => setLoader(false);
    }, [isLoadingCommunities]);
    const sgtCommunities = useMemo(() => {
        if (communitiesResp === null || communitiesResp === void 0 ? void 0 : communitiesResp.data) {
            return communitiesResp.data
                .map((community) => (Object.assign(Object.assign({}, community), { sgtEnabled: community.features.includes("SGT") })))
                .sort((a, b) => (a.sgtEnabled === b.sgtEnabled ? 0 : a.sgtEnabled ? -1 : 1));
        }
    }, [communitiesResp]);
    useEffect(() => {
        if ((sgtCommunities === null || sgtCommunities === void 0 ? void 0 : sgtCommunities.length) === 1 || (sgtCommunities === null || sgtCommunities === void 0 ? void 0 : sgtCommunities.filter((c) => c.sgtEnabled).length) === 0) {
            navigate(`${PATHS.SGT}/${sgtCommunities[0]._id}/${PATHS.SGT_SCHEDULES}`);
        }
    }, [sgtCommunities]);
    const handleCommunityPanelChange = (panelKey) => (event, isExpanded) => {
        if (isExpanded) {
            navigate(`${PATHS.SGT}/${panelKey}/${PATHS.SGT_SCHEDULES}`);
        }
        else {
            navigate(`${PATHS.SGT}`);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekStack, { direction: "column", spacing: 4, mt: 4 },
            React.createElement(PeekGrid, { item: true, xs: 12, display: "flex", justifyContent: "space-between" },
                React.createElement(PeekStack, { direction: "row", spacing: 4, alignItems: "center", height: theme.spacing(4) },
                    React.createElement(AppHeader, { headerLabel: intl.formatMessage(messages.sgtTitle), icon: React.createElement(PeekTypography, { variant: "h2", display: "flex" },
                            React.createElement(UserWalking, null)) }),
                    React.createElement(Policy, { action: "SGT" /* PolicyActions.SGT */, mode: "disable" },
                        React.createElement(SearchText, { searchText: searchKey, onChange: setSearchKey, placeholder: intl.formatMessage(messages.searchCommunity) })))),
            !usePolicyContext("SGT" /* PolicyActions.SGT */) && (React.createElement(PeekGrid, { item: true, xs: 12 },
                React.createElement(Banner, { imageSource: "/images/sgt_banner_image.png", bannerTheme: "light", title: intl.formatMessage(messages.bannerTitle), description: intl.formatMessage(messages.bannerDescription), items: [
                        intl.formatMessage(messages.bannerItem1),
                        intl.formatMessage(messages.bannerItem2),
                        intl.formatMessage(messages.bannerItem3),
                    ] }))),
            React.createElement(PeekStack, { direction: "column", spacing: 1 }, sgtCommunities === null || sgtCommunities === void 0 ? void 0 : sgtCommunities.map((community) => {
                const expanded = communityId === community._id;
                return (React.createElement(CommunityPanel, { key: community._id, expanded: expanded, onChange: handleCommunityPanelChange(community._id), title: React.createElement(React.Fragment, null,
                        community.name,
                        !community.sgtEnabled && (React.createElement(PeekBox, { component: "span", sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                bgcolor: "secondary.main",
                                color: "common.white",
                                p: 0.2,
                                borderRadius: 15,
                                ml: 0.5,
                                height: 12,
                                width: 12,
                            } },
                            React.createElement(Crown, null)))), communityId: community._id, disabled: !community.sgtEnabled }, !!expanded && React.createElement(CommunityTabs, { community: community })));
            })))));
};
export default SGTLayout;
